import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

function ToolsPage() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const tools = [
    {
      id: 'json-compare',
      name: 'JSON Compare',
      description: 'Compare two JSON documents and highlight differences',
      icon: '📊'
    }
  ];

  const getThemeClasses = () => {
    const baseClasses = {
      ocean: 'bg-blue-50 text-gray-900',
      sunset: 'bg-orange-50 text-gray-900',
      forest: 'bg-green-50 text-gray-900',
      midnight: 'bg-gray-900 text-gray-100'
    };
    return baseClasses[theme] || baseClasses.ocean;
  };

  const getCardThemeClasses = () => {
    const baseClasses = {
      ocean: 'bg-white border-gray-200 hover:border-blue-400 hover:shadow-lg',
      sunset: 'bg-white border-gray-200 hover:border-orange-400 hover:shadow-lg',
      forest: 'bg-white border-gray-200 hover:border-green-400 hover:shadow-lg',
      midnight: 'bg-gray-800 border-gray-700 hover:border-gray-500 hover:shadow-lg'
    };
    return baseClasses[theme] || baseClasses.ocean;
  };

  return (
    <div className={`min-h-screen p-8 ${getThemeClasses()}`}>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-4">Developer Tools</h1>
        <p className="text-lg mb-8 opacity-75">Select a tool to get started</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map((tool) => (
            <button
              key={tool.id}
              onClick={() => navigate(`/tools/${tool.id}`)}
              className={`p-6 rounded-lg border-2 transition-all duration-200 text-left ${getCardThemeClasses()}`}
            >
              <div className="text-4xl mb-4">{tool.icon}</div>
              <h2 className="text-2xl font-bold mb-2">{tool.name}</h2>
              <p className="opacity-75">{tool.description}</p>
            </button>
          ))}
        </div>

        <div className="mt-12 p-6 rounded-lg border-2 border-dashed opacity-50">
          <p className="text-center">More tools coming soon...</p>
        </div>
      </div>
    </div>
  );
}

export default ToolsPage;
